import type { ContentData } from '@valk-nx/storyblok-types/src/lib/types/content.interface';

export function transformContent(
	content: ContentData | null | undefined,
): string {
	if (
		content == null ||
		typeof content !== 'object' ||
		Array.isArray(content) ||
		!('type' in content)
	) {
		return '';
	}

	switch (content.type) {
		case 'array':
			return content.value.map((item) => `- ${item}`).join('\n');
		case 'markDown':
			return content.value.join('\n');
		case 'text':
			return content.value;
		default:
			return '';
	}
}
